import { KODE_STATUS_TYPE } from "../constants/StatusType.constants";

function isIzinMajuSidangButtonExist(kodeStatus) {
  if (
    kodeStatus === KODE_STATUS_TYPE.MAJU_SIDANG_BELUM_DISETUJUI ||
    kodeStatus === KODE_STATUS_TYPE.MENUNGGU_PEER_REVIEW ||
    kodeStatus === KODE_STATUS_TYPE.JADWAL_SIDANG_BELUM_DITENTUKAN ||
    kodeStatus === KODE_STATUS_TYPE.MENUNGGU_SIDANG
  ) {
    return true;
  }
  return false;
}

function isLihatBerkasButtonExist(kodeStatus) {
  if (kodeStatus === KODE_STATUS_TYPE.KODE_ETIK_DAN_ATAU_BERKAS_BELUM_DIISI) {
    return false;
  }
  return true;
}


function isLembarAndLabelExist(kodeStatus) {
  if (kodeStatus === KODE_STATUS_TYPE.KODE_ETIK_DAN_ATAU_BERKAS_BELUM_DIISI ||
    kodeStatus === KODE_STATUS_TYPE.MAJU_SIDANG_BELUM_DISETUJUI ||
    kodeStatus === KODE_STATUS_TYPE.JADWAL_SIDANG_BELUM_DITENTUKAN ||
    kodeStatus === KODE_STATUS_TYPE.MENUNGGU_PEER_REVIEW) {
    return false;
  }
  return true;
}


function isNilaiOrEvaluasiButtonExist(kodeStatus) {
  if (
    kodeStatus === KODE_STATUS_TYPE.KODE_ETIK_DAN_ATAU_BERKAS_BELUM_DIISI ||
    kodeStatus === KODE_STATUS_TYPE.MAJU_SIDANG_BELUM_DISETUJUI ||
    kodeStatus === KODE_STATUS_TYPE.JADWAL_SIDANG_BELUM_DITENTUKAN
  ) {
    return false;
  }
  return true;
}

function isAssignJadwalButtonExist(kodeStatus) {
  if (
    kodeStatus === KODE_STATUS_TYPE.JADWAL_SIDANG_BELUM_DITENTUKAN ||
    kodeStatus === KODE_STATUS_TYPE.MENUNGGU_SIDANG
  ) {
    return true;
  }
  return false;
}

function isEditAssignJadwal(kodeStatus) {
  if (kodeStatus === KODE_STATUS_TYPE.MENUNGGU_SIDANG) {
    return true;
  }
  return false;
}

export {
  isIzinMajuSidangButtonExist,
  isLihatBerkasButtonExist,
  isLembarAndLabelExist,
  isNilaiOrEvaluasiButtonExist,
  isAssignJadwalButtonExist,
  isEditAssignJadwal,
};
